import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

import { API } from '../lib/api';

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('propguard_token'));
  const [loading, setLoading] = useState(true);

  const setAuth = useCallback((tokenVal, userVal) => {
    setToken(tokenVal);
    setUser(userVal);
    if (tokenVal) {
      localStorage.setItem('propguard_token', tokenVal);
      axios.defaults.headers.common['Authorization'] = `Bearer ${tokenVal}`;
    } else {
      localStorage.removeItem('propguard_token');
      delete axios.defaults.headers.common['Authorization'];
    }
  }, []);

  useEffect(() => {
    const init = async () => {
      if (token) {
        try {
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          const res = await axios.get(`${API}/auth/me`);
          setUser(res.data);
        } catch {
          setAuth(null, null);
        }
      }
      setLoading(false);
    };
    init();
  }, [token, setAuth]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    setAuth(res.data.token, res.data.user);
    return res.data;
  };

  // Role is assigned server-side; the client cannot choose it.
  const register = async (email, password, full_name) => {
    const res = await axios.post(`${API}/auth/register`, { email, password, full_name });
    setAuth(res.data.token, res.data.user);
    return res.data;
  };

  const logout = () => {
    setAuth(null, null);
  };

  // Re-read the account, e.g. after a Pilot Pro purchase changes is_pro.
  const refreshUser = useCallback(async () => {
    const res = await axios.get(`${API}/auth/me`);
    setUser(res.data);
    return res.data;
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
